import { Environment } from "@/environments/environment";
import { Util } from "@/utils";

export function getSysUrl(path: any) {
  let redirectUrl: any = (Environment as any).WkdUrl;
  const hostOrigin: any = window.location.origin
  // 工单，基础数据，备件，runtime
  const prefixObj: any = {
    'csswkd': (Environment as any).WkdUrl,
    'cssbd': (Environment as any).BasicDataUrl,
    'cssre': (Environment as any).ReportUrl,
    'csssp': (Environment as any).SparePartsUrl,
    '/index': (Environment as any).RuntimeUrl
   }
  const key: any = Object.keys(prefixObj).filter((key: any) => path.includes(key) )[0]
  if (!key) return null
  redirectUrl = key ? prefixObj[key] : redirectUrl
  return redirectUrl.startsWith('http')
        ? `${redirectUrl}`
        : `${hostOrigin}${redirectUrl}`
}

export function postMessageToIframe(data: any, path: any, iframeInner: any) {
  if (!iframeInner) return
  let redirectUrl: any = getSysUrl(path)
  let url: any = redirectUrl.replace("/#", "/");
  postMessage(data, url, iframeInner)
}

export function postMessage(data:any, url:any, iframeInner: any) {
  if (iframeInner.attachEvent) {
    iframeInner.attachEvent("onload", handler(iframeInner, data, url));
  } else if (iframeInner.addEventListener) {
    iframeInner.addEventListener("onload", handler(iframeInner, data, url));
  } else {
    iframeInner.onload = handler(iframeInner, data, url);
  }
}

function handler(iframeInner: any, data: any, url: any) {
  iframeInner.contentWindow.postMessage(data, url);
}

export function menuJumpTo(path: any, item: any, context: any, viewtagparmas: any = '') {
  let finalPath: any = `/appindexview/null${path}`
  context.$router.push(finalPath);
  context.$emit('menuclick', path);
  if (viewtagparmas) {
    context.pagePath({pushTo: path})
  }
}